

export default {
  SET_KATEGORI_LIST(state, payload){
    state.kategoriList = payload
  },
  SET_TOTAL_BH(state, payload){
    state.totalBannerHome = payload
  },
  SET_TOTAL_BD(state, payload){
    state.totalBannerDonasi = payload
  },
  SET_TOTAL_BPPOB(state, payload){
    state.totalBannerPPOB = payload
  }
}
